module.exports = __webpack_public_path__ + "static/media/ViewTrans.4cc679c9.png";